import React, { lazy, Suspense } from 'react';

/**
 * Creates a code-split component that lazy loads only when needed
 * Can be used for routes, components, modals, or any React component
 *
 * @param {Function} importFunc - Dynamic import function
 * @param {Object} options - Configuration options
 * @param {React.ReactNode} options.fallback - Loading component/element
 * @returns {React.ComponentType} - A component wrapped with suspense
 */
const lazyLoad = (importFunc, { fallback = null } = { fallback: null }) => {
  const LazyComponent = lazy(importFunc);

  return (props) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default lazyLoad;
